import React from "react";
import RightArrow from "../../commons/images/arrow-right.png";
import checkIcon from "../../commons/images/check-icon.png";
import closeIcon from "../../commons/images/close-icon.png";
import Administrator from "../../commons/images/Administrator.png";
import ProjectManager from "../../commons/images/ProjectManager.png";
import Fabforeman from "../../commons/images/Fabforeman.png";
import DesignUser from "../../commons/images/designer.png";
import Procurement from "../../commons/images/Procurement.png";
import Fabrication from "../../commons/images/Fabrication.png";
import QAQC from "../../commons/images/QA&QC.png";
import fieldQa from "../../commons/images/field-qa.png";
import crewforeman from "../../commons/images/crewforeman.png";
import fieldForeman from "../../commons/images/field-foreman.png";
import fieldUser from "../../commons/images/field-user.png";
import WarehouseUser from "../../commons/images/warehouse.png";
import Examiner from "../../commons/images/examiner.png";

function RolePopup(props) {
  const renderIcons = (role) => {
    switch (role) {
      case "Administrator":
        return Administrator;
      case "Project Manager":
        return ProjectManager;
      case "Fab Foreman":
        return Fabforeman;
      case "Design User":
        return DesignUser;
      case "Procurement User":
        return Procurement;
      case "Fabrication":
        return Fabrication;
      case "Qa":
        return QAQC;
      case "Crew Foreman":
        return crewforeman;
      case "Field Foreman":
        return fieldForeman;
      case "Field Qa":
        return fieldQa;
      case "Field User":
        return fieldUser;
      case "Warehouse":
        return WarehouseUser;
      case "Examiner":
        return Examiner;
      default:
        return Examiner;
    }
  };

  return (
    <div className="user-role-wrapper">
      {props.showClose && (
        <div className="close-icon" onClick={() => props.onClose()}>
          <span>Close</span>

          <img className="close-img" src={closeIcon} alt="Close" />
        </div>
      )}

      <div className="user-role-header">
        <div className="title-form">Choose a role.</div>
        <p>Choosing any role below allows you to track the activity of that role.</p>
      </div>
      <div className="role-box-container">
        {props.userRoles.map((userRole, index) => {
          const isRoleMatched = props.roleId && props.roleId === userRole.role_id;
          const canDisable = isRoleMatched || userRole.disabled;

          return (
            <div
              key={index}
              className={canDisable ? `disabled-btn user-role-row` : `user-role-row`}
              onClick={() => (canDisable ? {} : props.handleRoleSelect(userRole))}
            >
              <div className="d-flex align-items-center">
                <div className="icon-imgs">
                  <img className="user-icon" src={renderIcons(userRole.role_name)} alt="User" />

                  {isRoleMatched && <img className="check-icon" src={checkIcon} alt="" />}
                </div>
                <div className="role-text">{userRole.role_name}</div>
              </div>

              <div className={`cont-btn`}>
                <span>Continue</span>

                <span>
                  <img className="arrow-icon" src={RightArrow} alt="" />{" "}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default RolePopup;
